import { IconSvgProps } from '../types';

export const TrelloListsVertical = ({ size }: IconSvgProps) => (
  <svg
    id="icon-software-trello lists"
    width={size}
    height={size}
    viewBox="0 0 71 65"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <path
          d="M44.87,42.6 C44.87,44.7 43.2,46.4 41.14,46.4 L29.95,46.4 C27.89,46.4 26.22,44.7 26.22,42.6 L26.22,3.9 C26.22,1.8 27.89,0.2 29.95,0.2 L41.14,0.2 C43.2,0.2 44.87,1.8 44.87,3.9 L44.87,42.6 Z"
          opacity="0.5"
        />
        <path d="M18.77,53.3 C18.77,55.4 17.1,57 15.04,57 L3.86,57 C1.8,57 0.13,55.4 0.13,53.3 L0.13,3.9 C0.13,1.8 1.8,0.2 3.86,0.2 L15.04,0.2 C17.1,0.2 18.77,1.8 18.77,3.9 L18.77,53.3 Z" />
        <path d="M70.96,60.4 C70.96,62.5 69.29,64.2 67.23,64.2 L56.05,64.2 C53.99,64.2 52.32,62.5 52.32,60.4 L52.32,3.9 C52.32,1.8 53.99,0.2 56.05,0.2 L67.23,0.2 C69.29,0.2 70.96,1.8 70.96,3.9 L70.96,60.4 Z" />
      </g>
    </g>
  </svg>
);
